import { useEffect, useState } from "react";
import { Button } from "components/UI/Buttons/Button";
import {
  SamplePageSampleCard,
  SamplePageSampleCardProps,
} from "components/pages/samples/SamplePageSampleCard";
import styles from "./CardList.module.scss";
import { useAppSelector } from "store/store";
import { sampleFilteredListSelector } from "store/slices/samplesSlice";
import { baseUrl, orderFormUrl } from "@/const";
import { useOrderForm, useOrderFormInitialSetup } from "@/lib/priceCalculator";
import IconArrowDown from "public/img/icons/svg/arrow-down.svg";

type CardListProps = {
  samplesList: (Omit<SamplePageSampleCardProps, "onClick"> & { id: string })[];
};

export const CardList = ({ samplesList }: CardListProps) => {
  const [count, setCount] = useState(5);
  const [list, setList] = useState(samplesList);
  const filteredSamples = useAppSelector(sampleFilteredListSelector);
  const [submitted, setSubmitted] = useState(false);

  const { config, formValues, setFormValues, defaults, dispatch } = useOrderFormInitialSetup(
    baseUrl,
    orderFormUrl
  );

  const { submit } = useOrderForm(config, formValues, defaults, baseUrl);

  useEffect(() => {
    if (submitted) submit();
  }, [submitted, submit]);

  const handleClick = () => {
    setCount(count + 5);
  };
  const renderCards = (list: (SamplePageSampleCardProps & { id: string })[]) => {
    if (list.length === 0)
      return (
        <div className={styles.empty}>
          Hmm... Looks like we can’t find a sample you are looking for. Make sure all details are correct or
          uncheck some boxes in the filter and try again.
        </div>
      );
    else
      return list.map(({ id, ...rest }, idx) => {
        if (idx < count)
          return (
            <SamplePageSampleCard
              key={id}
              {...rest}
              onClick={() => {
                setFormValues({
                  ...formValues,
                  units: rest.units,
                  idAcademicDiscipline: rest.idAcademicDiscipline,
                  idAcademicLevel: rest.idAcademicLevel,
                  idPaperType: rest.idPaperType,
                  idCitationStyle: rest.idCitationStyle,
                });
                setSubmitted(true);
              }}
            />
          );
      });
  };

  useEffect(() => {
    setList(filteredSamples);
  }, [filteredSamples]);

  return (
    <div className={styles.list}>
      {/* @ts-ignore*/}
      {renderCards(list)}
      {list.length > count && (
        <Button
          onClick={handleClick}
          className={styles.button}
          icon={IconArrowDown}
          iconPosition="suffix"
          type="primary"
          outline
        >
          Show more
        </Button>
      )}
    </div>
  );
};
